/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Status_Pulling_Latest_CommitInputs */



/**
* | output |
* | --- |
* | "Pulling latest commit..." |
*
* @param {Team_Project_Import_Status_Pulling_Latest_CommitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_status_pulling_latest_commit = /** @type {((inputs?: Team_Project_Import_Status_Pulling_Latest_CommitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Status_Pulling_Latest_CommitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Récupération du dernier commit...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der neueste Commit wird abgerufen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estrazione dell'ultimo commit...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка последнего коммита...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Extrayendo el último commit...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在拉取最新提交...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最新のコミットをプルしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नवीनतम कमिट को पुल किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Obtendo o commit mais recente...")
	return /** @type {LocalizedString} */ ("Pulling latest commit...")
});